import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { v_ConstructionJobInfo } from '@app/cp/shared/models/v_ConstructionJobInfo';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { SelectionEvent } from '@progress/kendo-angular-grid';

@Component({
    selector: 'job-information',
    templateUrl: './job-information.component.html',
    styleUrls: ['./job-information.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConstructionJobInformationComponent extends BaseGridComponent<v_ConstructionJobInfo, null> implements OnDestroy {
    rowSelected(e: SelectionEvent) {

    }
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private qry_rd: DQOIReferenceDataQuery, svc_data: ConstructionService) {
        super(globals, featureFlagService);
        this.svc_data = svc_data;
        this.aggregates = [
            { field: 'bidLabHrs', aggregate: 'sum' }
            , { field: 'actualLabHrs', aggregate: 'sum' }
            , { field: 'remainingLabHrs', aggregate: 'sum' }
            , { field: 'bidLabDollars', aggregate: 'sum' }
            , { field: 'actualLabDollars', aggregate: 'sum' }
            , { field: 'remainLabDollars', aggregate: 'sum' }
            , { field: 'bidMatDollars', aggregate: 'sum' }
            , { field: 'actualMatDollars', aggregate: 'sum' }
            , { field: 'remainMatDollars', aggregate: 'sum' }
            , { field: 'bidOtherDollars', aggregate: 'sum' }
            , { field: 'actualOtherDollars', aggregate: 'sum' }
            , { field: 'remainingOtherDollars', aggregate: 'sum' }
            , { field: 'totalTax', aggregate: 'sum' }
            , { field: 'profit', aggregate: 'sum' }
        ];

        this.subs_dataRef = this.qry_rd.ensureRefDataIsLoaded(this.globals.companyId).subscribe();
        this.subs_dataRefUpdated = this.qry_rd.referenceDataUpdated.subscribe((data: DQOIReferenceData) => {
            this.referenceData = data;
        });
    }
    subs_dataRef: Subscription;
    subs_dataRefUpdated: Subscription;
    svc_data: ConstructionService;
    referenceData: DQOIReferenceData;
    contractAdministratorId: any;
    customerId: any;
    jobClassIds: any;
    relatedCategoryIds: any;
    dispatchStatusIds: any;
    constractNo: string;

    loading: boolean = false;
    dataRequested: boolean = false;

    override ngOnDestroy() {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.subs_dataRef);
        CommonFunctions.unsubscribe(this.subs_dataRefUpdated);
    }

    getData() {
        this.loading = true;
        this.dataRequested = true;
        let param: ConstructionSearchParam = this.getParam();
        this.svc_data.getConstructionJobInfo(param).subscribe(data => {
            this.gridData = data;
            this.cloneData();
            this.processGridData();
            this.loading = false;
        });
    }

    getParam(initial: boolean = false) : ConstructionSearchParam {
        let param: ConstructionSearchParam = new ConstructionSearchParam();
        if (!initial) {
            param.userId = this.globals.userId;
            param.companyId = this.globals.companyId;
            param.constAdmins = this.contractAdministratorId;
            param.customerId = this.customerId;
            param.jobClassIds = this.jobClassIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.jobClassIds);
            param.jobTypeIds = this.relatedCategoryIds; //  CommonFunctions.getArrayFromCommaDelimitedString(this.relatedCategoryIds);
            param.dispatchStatusIds = this.dispatchStatusIds; // CommonFunctions.getArrayFromCommaDelimitedString(this.dispatchStatusIds);
            param.contractNo = this.constractNo;
        }
        return param;
    }

    apiFilter() {
        this.getData();
    }

    searchGrid() {
        this.getData();
    }

    clearFilters() {
        this.contractAdministratorId = null;
        this.customerId = null;
        this.jobClassIds = null;
        this.relatedCategoryIds = null;
        this.dispatchStatusIds = null;
        this.getData();
    }

    resetGrid() {

    }

    export() {

    }

    //processGridData() {
    //    if (CommonFunctions.hasArrayElementValue(this.gridData)) {
    //        this.aggregateResults = aggregateBy(this.gridData, this.aggregates);
    //    }
    //}
}
